import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface AuctionState {
  currentAuctionIndex: number
  isLastAuction: boolean
}

const initialState: AuctionState = {
  currentAuctionIndex: 0,
  isLastAuction: false
}

export const AuctionSlice = createSlice({
  name: "auction",
  initialState,
  reducers: {
    setCurrentAuctionIndex: (state, { payload }: PayloadAction<number>) => {
      state.currentAuctionIndex = payload
    },
    incrementCurrentAuctionIndex: (state) => {
      state.currentAuctionIndex++
    },
    decrementCurrentAuctionIndex: (state) => {
      state.currentAuctionIndex--
    },
    setIsLastAuction: (state, { payload }: PayloadAction<boolean>) => {
      state.isLastAuction = payload
    }
  },
  extraReducers: () => {}
})

export const {
  setCurrentAuctionIndex,
  incrementCurrentAuctionIndex,
  decrementCurrentAuctionIndex,
  setIsLastAuction
} = AuctionSlice.actions
